<script lang="ts">
	import { getNumBackInUnits, trimString } from '$lib/util/util';
	import { walletConnected } from '$lib/wallet/store';
	import { flip } from 'svelte/animate';
	import { quintOut } from 'svelte/easing';

	import { smartContractSideMenuOpen, smartWalletName } from './store';
	import { smartContractWalletAddress } from './store';
	import ScWallet from './SCWallet.svelte';
	import { userMarginBalanceForTrade } from '../userInteract/store';
	import { browser } from '$app/environment';

	import { fly } from 'svelte/transition';
	import TradingSeasonPointsAndXpButton from './TradingSeasonPointsAndXpButton.svelte';
	import { page } from '$app/stores';
	import ScWalletButton from './SCWalletButton.svelte';

	function closeMenu() {
		$smartContractSideMenuOpen = false;
	}
	function openMenu() {
		$smartContractSideMenuOpen = true;
	}

	$: if (browser && $smartContractWalletAddress) {
		smartWalletName.set(
			window.localStorage.getItem(`walletName-${$smartContractWalletAddress}`) ?? 'Smart Wallet'
		);
	}
</script>

{#if $walletConnected}
	{#if $page.url.pathname !== '/mystery-orbs'}
		<ScWalletButton {openMenu} />
	{:else}
		<div class="animated-trading-season-teaser">
			<TradingSeasonPointsAndXpButton {openMenu} />
		</div>
		<div class="animated-trading-season-teaser animated-trading-season-coming-soon">
			<p class="text-base text-fx-gradient-1 font-bold">Coming Soon</p>
		</div>
		<div class="sc-wallet-button-delay">
			<ScWalletButton {openMenu} />
		</div>
	{/if}
{/if}
<!-- drawer component -->
{#if $smartContractSideMenuOpen}
	<div
		class="absolute w-full h-screen flex justify-end top-0 right-0 z-10"
		transition:fly={{ x: '100%', duration: 300 }}
	>
		<button on:click={closeMenu} on:keydown={closeMenu} class="w-full fixed h-screen" />
		<div
			class="fixed w-full sm:w-[28%] 2xl:max-w-[550px] bg-fx-gradient-8 right-0 top-0 h-screen z-50 transition-right duration-500 flex flex-col justify-start"
		>
			<div class="flex justify-between w-full">
				<div class="text-fx-gradient-9 text-2xl font-medium" />
				<button class="text-fx-grey-200 pr-4 pt-4" on:click={closeMenu}>
					<img src={'close.png'} loading="lazy" alt="" />
				</button>
			</div>
			<ScWallet />
		</div>
	</div>
{/if}

<style>
	.animated-trading-season-teaser {
		animation: switch 4s 1 linear forwards;
		opacity: 0;
		animation-fill-mode: forwards;
	}

	.animated-trading-season-coming-soon {
		animation-delay: 4s;
		opacity: 0;
		visibility: hidden;
		margin-top: -25px;
	}

	.sc-wallet-button-delay {
		animation: make-visible 1s linear forwards;
		animation-delay: 8s;
		opacity: 0;
		visibility: hidden;
		margin-top: -62px;
		max-width: 0px;
	}

	@keyframes make-visible {
		0% {
			max-width: fit-content;
			margin-top: 0px;
			visibility: visible;
			opacity: 1;
		}
		100% {
			max-width: fit-content;
			margin-top: 0px;
			visibility: visible;
			opacity: 1;
		}
	}

	@keyframes switch {
		0% {
			margin-top: 0px;
			visibility: visible;
			opacity: 0;
			filter: blur(20px);
			transform: scale(12);
		}
		20% {
			margin-top: 0px;
			opacity: 1;
			filter: blur(0);
			transform: scale(1);
		}
		75% {
			margin-top: 0px;
			opacity: 1;
			filter: blur(0);
			transform: scale(0.9);
		}
		100% {
			margin-top: 0px;
			opacity: 0;
			filter: blur(10px);
			transform: scale(0.1);
			display: none;
		}
	}
</style>
